import React from 'react';

import { primary } from '../../colors';
import { h1 } from '../../fontSizes';
import { mediumMargin } from '../../margins';
import headingGraphics from './headingGraphics.svg';

export const Heading = ({ children, innerRef, className, ...restProps }) => (
  <h2
    ref={innerRef}
    css={`
          text-align: center;
          font-size: ${h1};
          color: ${primary};
          font-weight: 700;
          text-transform: uppercase;
          margin-bottom: ${mediumMargin};

          &::after {
            display: block;
            content: '';
            height: 16px;
            width: auto;
            transform: translateY(-4px);
            background: url("${headingGraphics}")  center center / contain no-repeat;
          }

          ${className}
        `}
    {...restProps}
  >
    {children}
  </h2>
);



// WEBPACK FOOTER //
// ./app/components/Heading/Heading.js